import React, { useState, useEffect } from 'react';

const BirdMascot = ({ size = 80, color = '#FF6B6B', className = '' }) => {
  const [isBlinking, setIsBlinking] = useState(false);
  const [eyePosition, setEyePosition] = useState(0); // -1 = left, 0 = center, 1 = right

  useEffect(() => {
    // Blinking animation
    const scheduleNextBlink = () => {
      const delay = Math.random() * 3000 + 2000;
      setTimeout(() => {
        setIsBlinking(true);
        setTimeout(() => {
          setIsBlinking(false);
          scheduleNextBlink();
        }, 150);
      }, delay);
    };

    scheduleNextBlink();
  }, []);

  useEffect(() => {
    // Eye movement animation - suspicious looking around
    const scheduleEyeMovement = () => {
      const delay = Math.random() * 2000 + 1000; // Random between 1-3 seconds
      setTimeout(() => {
        const positions = [-1, 0, 1]; // left, center, right
        const newPosition = positions[Math.floor(Math.random() * positions.length)];
        setEyePosition(newPosition);
        scheduleEyeMovement();
      }, delay);
    };

    scheduleEyeMovement();
  }, []);

  // Calculate eye pupil positions based on eyePosition
  const leftPupilX = 42 + (eyePosition * 2); // Moves -2, 0, or +2 from center
  const rightPupilX = 58 + (eyePosition * 2);

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      className={className}
      style={{ display: 'inline-block' }}
    >
      {/* Body - egg shaped */}
      <ellipse cx="50" cy="55" rx="28" ry="32" fill={color} />
      {/* Head merged with body */}
      <circle cx="50" cy="35" r="20" fill={color} />
      
      {/* Eyes - conditional rendering based on blinking state */}
      {isBlinking ? (
        // Closed eyes (horizontal lines)
        <>
          <path d="M 35 32 Q 42 33 49 32" stroke="#000" strokeWidth="3" fill="none" strokeLinecap="round" />
          <path d="M 51 32 Q 58 33 65 32" stroke="#000" strokeWidth="3" fill="none" strokeLinecap="round" />
        </>
      ) : (
        // Open eyes with moving pupils
        <>
          {/* Left eye */}
          <circle cx="42" cy="32" r="7" fill="#FFF" />
          <circle cx={leftPupilX} cy="33" r="5" fill="#000" style={{ transition: 'cx 0.3s ease' }} />
          <circle cx={leftPupilX - 2} cy="31" r="2" fill="#FFF" />
          
          {/* Right eye */}
          <circle cx="58" cy="32" r="7" fill="#FFF" />
          <circle cx={rightPupilX} cy="33" r="5" fill="#000" style={{ transition: 'cx 0.3s ease' }} />
          <circle cx={rightPupilX - 2} cy="31" r="2" fill="#FFF" />
        </>
      )}
      
      {/* Tiny beak open */}
      <path 
        d="M 50 38 L 48 42 L 52 42 Z" 
        fill="#FFA500" 
        stroke="#000" 
        strokeWidth="1"
      />
      
      {/* Wings */}
      <ellipse 
        cx="28" 
        cy="50" 
        rx="8" 
        ry="15" 
        fill={color}
        opacity="0.8"
        transform="rotate(-15 28 50)"
      />
      <ellipse 
        cx="72" 
        cy="50" 
        rx="8" 
        ry="15" 
        fill={color}
        opacity="0.8"
        transform="rotate(15 72 50)"
      />
      
      {/* Feet */}
      <g>
        <path d="M 42 82 L 40 88 M 42 82 L 44 88" stroke="#FFA500" strokeWidth="2" strokeLinecap="round" />
        <path d="M 58 82 L 56 88 M 58 82 L 60 88" stroke="#FFA500" strokeWidth="2" strokeLinecap="round" />
      </g>
    </svg>
  );
};

export default BirdMascot;
